import { checkPermissionRoleScreen } from '@/router/main';

function createRoute(path, name, typeRole, component) {
    return {
        path: path,
        name: name,
        beforeEnter: (to, from, next) => {
            return next(checkPermissionRoleScreen(typeRole));
        },
        component: component
    };
}
const routes = [
    createRoute('/member', 'memberList', 'type_admin', () => import('@/views/member/list')),
    createRoute('/member/add', 'addMember', 'type_admin', () => import('@/views/member/edit')),
    createRoute('/member/edit', 'editMember', 'type_admin', () => import('@/views/member/edit')),
    createRoute('/member/user-info', 'userInfo', 'type_all', () => import('@/views/member/profile'))
];
export default routes;
